module.exports = __webpack_public_path__ + "media/images/flags/16/Guyana-c3b14934b44097b57797b9dba18dba51.png";